import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: _normalizeClass([
			..._ctx.classes,
			{ 'ActLoadingWrapper': _ctx.isLoading }
		])
  }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.contentIsActive)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "LoadingContent ActDashboardBlockIcon" }, null, -1 /* CACHED */)),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ActDashboardBlockContent" }, [
                    _createElementVNode("div", { class: "LoadingContent ActDashboardTitleSmall" }),
                    _createElementVNode("div", { class: "LoadingContent ActDashboardSubtitleSmall" })
                  ], -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "LoadingContent ActDashboardBlockImage" }, null, -1 /* CACHED */)),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "InactiveDashboardContentWrapper" }, [
                    _createElementVNode("div", { class: "LoadingContent ActDashboardBlockIcon" }),
                    _createElementVNode("div", { class: "ActDashboardBlockContent" }, [
                      _createElementVNode("div", { class: "LoadingContent ActDashboardTitleSmall" }),
                      _createElementVNode("div", { class: "LoadingContent ActDashboardSubtitleSmall" })
                    ])
                  ], -1 /* CACHED */)),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "LoadingContent ActDashboardLearnMoreButton" }, null, -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]))
}